<mat-card *ngFor="let course of courses" class="course-card mat-elevation-z10">

  <mat-card-header>

    <mat-card-title>{{course.description}}</mat-card-title>

  </mat-card-header>

  <img mat-card-image [src]="course.iconUrl">

  <mat-card-content>
    <p>{{course.longDescription}}</p>
  </mat-card-content>

  <mat-card-actions class="course-actions">

    <button mat-button class="mat-raised-button mat-primary" [routerLink]="['/courses', course.url]">
      VIEW COURSE
    </button>

    <ng-container>
      <ng-container>
        <button mat-button class="mat-raised-button mat-accent"
                (click)="editCourse(course)">
          EDIT
        </button>
        <button mat-mini-fab color="warn">
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>
    </ng-container>

  </mat-card-actions>

</mat-card>
